import { HGroup } from "../area/HGroup";
import { SC_Input } from '../input/SC_Input';
import { TranslateService } from "../variables/translate-service";
import { Sol50Integrated } from "./Sol50Integrated";
import { Sol50OnRoof } from "./Sol50OnRoof";

import { Hip } from "../roof/Hip";
import { PartialHip } from "../roof/PartialHip";
import { Rectangular } from "../roof/Rectangular";
import { RoofType } from "../roof/RoofType";

import { Statics } from "../utilities/statics";
import { getAllInString } from './getAllInString';
import { getAllInStringIntegrated } from './getAllInStringIntegrated';
import { MountingType } from "./MountingType";
import { RoofItemType } from './roofItemType';


export class MountingSystem {
    constructor(
        public translate: TranslateService
    ) {
    }
    public static MOUNTSYS_UNKNOWN: number = 0;
    public static SOL50_PREM_2M: number = 1; //1
    public static SOL50_STAN_4M: number = 2;
    public static SOL50_PREM_4M: number = 3;  //1
    public static SOL50_PREM_IN: number = 4; //1
    public static SOL50_STAN_IN: number = 5;
    public static SOL50_BASIS: number = 6;
    public static SOL50_50S: number = 7;
    public static SOL50_50IS: number = 8;
    public static SOL50_STAN_2M: number = 9;
    public static MS_SOLSMART: number = 10;
    public static SOL30_2M: number = 11;
    public static SOL30_2M_Black: number = 12;
    public static SOL30_4M: number = 13;
    public static SOL30_4M_Black: number = 14;

    public static SOL50_COLOR_NONE: number = 0;
    public static SOL50_COLOR_PB: number = 1;
    public static SOL50_COLOR_SI: number = 2;
    public static SOL50_COLOR_SW: number = 3;

    public static bGroupsValid: boolean = false;
    private static aMarkers: any[];
    public static bMarkers: boolean = false;

    public static getErrorInvalidGroups(): boolean {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            return true;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            return true;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            return true;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            return true;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            return true;
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            return true;
        }
        return false;
    }

    //commented due to error
    public static Groups_change(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            Sol50OnRoof.createGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            Sol50OnRoof.createGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            Sol50OnRoof.createGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            Sol50OnRoof.createGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            Sol50Integrated.createGroups();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            Sol50OnRoof.createGroups();
        }
    }

    public static getStocklist(): RoofItemType[] {
        let sRet: RoofItemType[] = [];
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            sRet = getAllInString();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            sRet = getAllInString();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            sRet = getAllInString();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            sRet = getAllInString();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            sRet = getAllInStringIntegrated(); //Sol50Integrated.getAllInString();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            sRet = getAllInString();
        }
        return sRet;
    }

    public static fitRechteck(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            new Rectangular().fitRect();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            new Rectangular().fitRect();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            new Rectangular().fitRect();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            new Rectangular().fitRect();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            new Rectangular().fitRectInroof();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            new Rectangular().fitRect();
        }
    }

    public static fitWalm(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            new Hip().fitWalm();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            new Hip().fitWalm();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            new Hip().fitWalm();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            new Hip().fitWalm();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            new Hip().fitWalmIndach();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            new Hip().fitWalm();
        }
    }

    public static fitKrueppelwalm(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            new PartialHip().fitPartialHip();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            new PartialHip().fitPartialHip();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            new PartialHip().fitPartialHip();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            new PartialHip().fitPartialHip();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            new PartialHip().fitPartialHipIntegrated();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            new PartialHip().fitPartialHip();
        }
    }
    // due to errors
    public static showGroups(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            Sol50OnRoof.showGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            Sol50OnRoof.showGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            Sol50OnRoof.showGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            Sol50OnRoof.showGroups();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            // Sol50Integrated.showGroups();
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            Sol50OnRoof.showGroups();
        }
    }

    private static rememberMarker(_x: number, _y: number, _l: number = 5, _bVertical: boolean = false): void {
        MountingSystem.aMarkers.push([_x, _y, _l, _bVertical]);
    }

    public static getDistAdapVar(nThick: number): string {
        var sVar: string = "";
        switch (nThick) {
            case 4.6:
            case 4.5:
                sVar = "DISTADAP-75-45-46";
                break;
            case 4.2:
            case 4.1:
                sVar = "DISTADAP-75-41-42";
                break;
            case 4.0:
            case 3.9:
                sVar = "DISTADAP-75-39-40";
                break;
            case 3.8:
            case 3.7:
                sVar = "DISTADAP-75-37-38";
                break;
            case 3.6:
            case 3.5:
                sVar = "DISTADAP-75-35-36";
                break;
            case 3.3:
            case 3.2:
                sVar = "DISTADAP-75-32-33";
                break;
            case 3.1:
            case 3.0:
                sVar = "DISTADAP-75-30-31";
                break;
            default:
                sVar = "DISTUNI200-50";
                break;
        }
        return sVar;
    }

    public static updateHProfileVar(sVar: string): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M || SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SW) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW2ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW2ML";
                    }
                } else {
                    if (sVar == "hprofile_xxl") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
                            Sol50OnRoof.sHProfileVar = "S30PRHPSW2MXXL";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50PRHPSW2MXXL";
                        }
                    } else if (sVar == "hprofile_l") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
                            Sol50OnRoof.sHProfileVar = "S30PRHPSW2ML";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50PRHPSW2ML";
                        }
                    }
                }
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M || SC_Input.iMountSys == MountingSystem.SOL30_2M) {
            // console.log('iFrameColor',SC_Input.iFrameColor);
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_PB) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB2ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB2ML";
                    }
                } else {
                    if (sVar == "hprofile_xxl") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_2M) {
                            Sol50OnRoof.sHProfileVar = "S30STHPPB2MXXL";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50STHPPB2MXXL";
                        }
                    } else if (sVar == "hprofile_l") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_2M) {
                            Sol50OnRoof.sHProfileVar = "S30STHPPB2ML";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50STHPPB2ML";
                        }
                    }
                }
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M || SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SW) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW4ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW4ML";
                    }
                } else {
                    if (sVar == "hprofile_xxl") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
                            Sol50OnRoof.sHProfileVar = "S30PRHPSW4MXXL";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50PRHPSW4MXXL";
                        }
                    } else if (sVar == "hprofile_l") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
                            Sol50OnRoof.sHProfileVar = "S30PRHPSW4ML";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50PRHPSW4ML";
                        }
                    }
                }
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M || SC_Input.iMountSys == MountingSystem.SOL30_4M) {
            // console.log(234, SC_Input.iFrameColor)
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_PB) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB4ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB4ML";
                    }
                } else {
                    if (sVar == "hprofile_xxl") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_4M) {
                            Sol50OnRoof.sHProfileVar = "S30STHPPB4MXXL";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50STHPPB4MXXL";
                        }
                    } else if (sVar == "hprofile_l") {
                        if (SC_Input.iMountSys == MountingSystem.SOL30_4M) {
                            Sol50OnRoof.sHProfileVar = "S30STHPPB4ML";
                        } else {
                            Sol50OnRoof.sHProfileVar = "S50STHPPB4ML";
                        }
                    }
                }
            }
        }
    }

    public static setVariables(): void {
        // console.log('MountingSystem.setVariables()', SC_Input.nModThick );
        //reset variables
        Sol50OnRoof.sDistAdapVar = "";
        Sol50Integrated.sDistAdapVar = "";
        // console.log(" INTO setVariables")
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M || SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
            if (SC_Input.nModThick == 5) {
            } else if (SC_Input.nModThick < 5) {
                Sol50OnRoof.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
            }
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SW) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW2ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW2ML";
                    }
                } else {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW2MXXL";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW2MXXL";
                    }
                }
                Sol50OnRoof.sAbschBlendVar = "S50PRABSW2M";
                Sol50OnRoof.sHAbKapVar = "HPENDKELSW10";
            }
            Sol50OnRoof.nAbschBlendLen = 200;
            Sol50OnRoof.nHProfileLen = 200;
            Sol50OnRoof.nVProfileLen = 200;
            Sol50OnRoof.sKabFanNetVar = "KABFNETZ14";
            if (SC_Input.iRoofType == RoofType.PANTILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
                if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                    Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                    Sol50OnRoof.sHVerbVar = "S50HV300MM";
                    Sol50OnRoof.sVVerbVar = "S50VV150MM";
                    Sol50OnRoof.sVProfileVar = "S50VPPB2MXXL";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
                } else if (SC_Input.iMountingType == MountingType.DIRECT) {
                    Sol50OnRoof.sVAbKapVar = "";
                    Sol50OnRoof.sHVerbVar = "";
                    Sol50OnRoof.sVVerbVar = "";
                    Sol50OnRoof.sVProfileVar = "";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR-AS-100";
                }
            } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV150MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.SLATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M || SC_Input.iMountSys == MountingSystem.SOL30_2M) {
            // console.log("INTO SOL50_STAN_2M || SOL30_2M", SC_Input.nModThick);
            if (SC_Input.nModThick == 5) {
            } else if (SC_Input.nModThick < 5) {
                Sol50OnRoof.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
            }
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_PB) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB2ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB2ML";
                    }
                } else {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_2M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB2MXXL";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB2MXXL";
                    }
                }
                Sol50OnRoof.sAbschBlendVar = "S50STABPB2M";
                Sol50OnRoof.sHAbKapVar = "HPENDKPB10";
            }
            Sol50OnRoof.nAbschBlendLen = 200;
            Sol50OnRoof.nHProfileLen = 200;
            Sol50OnRoof.nVProfileLen = 200;
            Sol50OnRoof.sKabFanNetVar = "";
            if (SC_Input.iRoofType == RoofType.PANTILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
                if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                    Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                    Sol50OnRoof.sHVerbVar = "S50HV300MM";
                    Sol50OnRoof.sVVerbVar = "S50VV150MM";
                    Sol50OnRoof.sVProfileVar = "S50VPPB2MXXL";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
                } else if (SC_Input.iMountingType == MountingType.DIRECT) {
                    Sol50OnRoof.sVAbKapVar = "";
                    Sol50OnRoof.sHVerbVar = "";
                    Sol50OnRoof.sVVerbVar = "";
                    Sol50OnRoof.sVProfileVar = "";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR-AS-100";
                }
            } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV150MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.SLATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB2MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M || SC_Input.iMountSys == MountingSystem.SOL30_4M) {
            if (SC_Input.nModThick == 5) {
            } else if (SC_Input.nModThick < 5) {
                Sol50OnRoof.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
            }
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_PB) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB4ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB4ML";
                    }
                } else {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M) {
                        Sol50OnRoof.sHProfileVar = "S30STHPPB4MXXL";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50STHPPB4MXXL";
                    }
                }
                Sol50OnRoof.sAbschBlendVar = "S50STABPB4M";
                Sol50OnRoof.sHAbKapVar = "HPENDKPB10";
            }
            Sol50OnRoof.nAbschBlendLen = 400;
            Sol50OnRoof.nHProfileLen = 400;
            Sol50OnRoof.nVProfileLen = 400;
            Sol50OnRoof.sKabFanNetVar = "";
            if (SC_Input.iRoofType == RoofType.PANTILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
                if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                    Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                    Sol50OnRoof.sHVerbVar = "S50HV300MM";
                    Sol50OnRoof.sVVerbVar = "S50VV150MM";
                    Sol50OnRoof.sVProfileVar = "S50VPPB4MXXL";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
                } else if (SC_Input.iMountingType == MountingType.DIRECT) {
                    Sol50OnRoof.sVAbKapVar = "";
                    Sol50OnRoof.sHVerbVar = "";
                    Sol50OnRoof.sVVerbVar = "";
                    Sol50OnRoof.sVProfileVar = "";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR-AS-100";
                }
            } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV150MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.SLATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M || SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
            if (SC_Input.nModThick == 5) {
            } else if (SC_Input.nModThick < 5) {
                Sol50OnRoof.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
            }
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SW) {
                if (SC_Input.iMountingType == MountingType.DIRECT) {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW4ML";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW4ML";
                    }
                } else {
                    if (SC_Input.iMountSys == MountingSystem.SOL30_4M_Black) {
                        Sol50OnRoof.sHProfileVar = "S30PRHPSW4MXXL";
                    } else {
                        Sol50OnRoof.sHProfileVar = "S50PRHPSW4MXXL";
                    }
                }
                Sol50OnRoof.sAbschBlendVar = "S50PRABSW4M";
                Sol50OnRoof.sHAbKapVar = "HPENDKELSW10";
            }
            Sol50OnRoof.nAbschBlendLen = 400;
            Sol50OnRoof.nHProfileLen = 400;
            Sol50OnRoof.nVProfileLen = 400;
            Sol50OnRoof.sKabFanNetVar = "KABFNETZ14";
            if (SC_Input.iRoofType == RoofType.PANTILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
                if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                    Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                    Sol50OnRoof.sHVerbVar = "S50HV300MM";
                    Sol50OnRoof.sVVerbVar = "S50VV150MM";
                    Sol50OnRoof.sVProfileVar = "S50VPPB4MXXL";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
                } else if (SC_Input.iMountingType == MountingType.DIRECT) {
                    Sol50OnRoof.sVAbKapVar = "";
                    Sol50OnRoof.sHVerbVar = "";
                    Sol50OnRoof.sVVerbVar = "";
                    Sol50OnRoof.sVProfileVar = "";
                    Sol50OnRoof.sDrillScrewVar = "BOHRSR-AS-100";
                }
            } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV150MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.SLATED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
                Sol50OnRoof.sVAbKapVar = "VPENDKELSW10";
                Sol50OnRoof.sHVerbVar = "S50HV300MM";
                Sol50OnRoof.sVVerbVar = "S50VV100MM";
                Sol50OnRoof.sVProfileVar = "S50VPPB4MXL";
                Sol50OnRoof.sDrillScrewVar = "BOHRSR6,3-22-100";
            }
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SI) {
                if (SC_Input.nModThick == 5) {
                    Sol50Integrated.sHProfilVar = "IDPRHP50STELSI";
                } else if (SC_Input.nModThick < 5) {
                    Sol50Integrated.sHProfilVar = "IDPRHP50STELSI";
                    Sol50Integrated.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
                } else {
                    Sol50Integrated.sHProfilVar = "";
                }
                Sol50Integrated.sAbschSteckVar = "S50STABPB2M";
                Sol50Integrated.sEindeckblechVar = "IDPR50SEITESW";
                Sol50Integrated.sTraufLuftProfVar = "IDPRTRAUFE2m";
                Sol50Integrated.sHAbschKapESVar = "HPENDKELSI10";
                Sol50Integrated.sKabFanNetVar = "KABFNETZ14";
                Sol50Integrated.sVDichtSVar = "IDPRSILIDICHTSI";
            } else if (SC_Input.iFrameColor == MountingSystem.SOL50_COLOR_SW) {
                if (SC_Input.nModThick == 5) {
                    Sol50Integrated.sHProfilVar = "IDPRHP50STELSW";
                } else if (SC_Input.nModThick < 5) {
                    Sol50Integrated.sHProfilVar = "IDPRHP50STELSW";
                    Sol50Integrated.sDistAdapVar = MountingSystem.getDistAdapVar(SC_Input.nModThick);
                } else {
                    Sol50Integrated.sHProfilVar = "";
                }
                Sol50Integrated.sAbschSteckVar = "S50PRABSW2M";
                Sol50Integrated.sEindeckblechVar = "IDPR50SEITESW";
                Sol50Integrated.sTraufLuftProfVar = "IDPRTRAUFE2m";
                Sol50Integrated.sHAbschKapESVar = "HPENDKELSW10";
                Sol50Integrated.sKabFanNetVar = "KABFNETZ14";
                Sol50Integrated.sVDichtSVar = "IDPRSILIDICHTSW";
            }
            Sol50Integrated.sLuKamVar = "IDPRKAMM2m";
            Sol50Integrated.sTopAbschlussblechVar = "IDPR50ABSOBEN";
            if (SC_Input.sIDAnsKleBanCol == "black") {
                Sol50Integrated.sAnKleBanVar = "IDKLEBANDSW450mm";
            } else {
                Sol50Integrated.sAnKleBanVar = "IDKLEBANDROT450mm";
            }
            Sol50Integrated.sEckAnsVar = "IDPRECK";
            Sol50Integrated.sDichtbandVar = "IDDICHTBAND10x3-25";
            Sol50Integrated.sHafKleHalVar = "IDHKLH-50";
            Sol50Integrated.sAbschBlechVar = "IDPR50ABSS65";
            Sol50Integrated.nHProfilLen = 200;
        }
        if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            // As per Sol30 Profiles, distance adapters are no longer required. Therefore, I have bypassed the "Distance Adapters" calculations from the item list
            Sol50OnRoof.sDistAdapVar = "";
            Sol50Integrated.sDistAdapVar = "";
        }
    }

    public static rememberObjects(): void {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            SC_Input.aHGroups = Sol50OnRoof.aHGroups;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            SC_Input.aHGroups = Sol50OnRoof.aHGroups;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            SC_Input.aHGroups = Sol50OnRoof.aHGroups;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            SC_Input.aHGroups = Sol50OnRoof.aHGroups;
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
            SC_Input.aHGroups = Sol50Integrated.aHGroups;
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            SC_Input.aHGroups = Sol50OnRoof.aHGroups;
        }
    }

    public static checkCantilever(): boolean {
        if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {
            return Statics.checkCantileverSOL50();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_2M) {
            return Statics.checkCantileverSOL50();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
            return Statics.checkCantileverSOL50();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {
            return Statics.checkCantileverSOL50();
        } else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
        } else if (SC_Input.iMountSys > 10 && SC_Input.iMountSys < 15) {
            return Statics.checkCantileverSOL50();
        }
        return true;
    }
    // due to error
    public static collectPanelGroups(): string {
        var i: number;
        var hgroupTmp: HGroup;
        var sOut: string;
        sOut = "";
        for (i = 0; i < SC_Input.aHGroups.length; i++) {
            hgroupTmp = SC_Input.aHGroups[i];
            sOut += hgroupTmp.iCnt.toString() + ":" + hgroupTmp.height.toString() + ":" + hgroupTmp.x.toString() + ":" + hgroupTmp.y.toString() + "|";
        }
        return sOut;
    }

    public static isPremium(_iMountSys: number): boolean {
        var bRet: boolean;
        if (_iMountSys == MountingSystem.SOL50_PREM_IN) {
            bRet = true;
        } else if (_iMountSys == MountingSystem.SOL50_PREM_4M) {
            bRet = true;
        } else if (_iMountSys == MountingSystem.SOL50_PREM_2M) {
            bRet = true;
        } else {
            bRet = false;
        }
        return bRet;
    }

    public static isInRoof(_iMountSys: number): boolean {
        var bRet: boolean;
        if (_iMountSys == MountingSystem.SOL50_PREM_IN) {
            bRet = true;
        } else {
            bRet = false;
        }
        return bRet;
    }

    public static hasStatics(): boolean {
        var bRet: boolean;
        bRet = false;
        if (SC_Input.bInRoof) {
        } else {
            if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
                if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                    bRet = true;
                }
            } else {
                bRet = true;
            }
        }
        return bRet;
    }
}
